import { Component } from 'react';
import {connect} from 'react-redux';
import {actions} from 'forms/rrf';
import {Col, Container, Row} from 'react-bootstrap';
import EditPointsTypeForm from './points-type-form';
import BackLink from '../../../common/back-link/index';
import PageTitle from '../../../common/page-title/index';
import {getPointsType} from '../../../../actions/points-types';

class EditPointsType extends Component {
  componentDidMount() {
    const id = +this.props.match.params.id;
    this.props.dispatch(getPointsType(id));
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.pointsType'));
    this.props.dispatch({type: 'CLEAR_EDIT_POINTS_TYPE'});
  }

  render() {
    const { pointsType } = this.props;

    return (
      <Container fluid className="points-type">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/points-types"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>
              Edit points type
            </PageTitle>
            { pointsType && (
              <EditPointsTypeForm
                pointsType={pointsType}
              />
            )}
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  pointsType: state.pointsTypes.pointsType,
  fetched: state.pointsTypes.fetched,
  fetching: state.pointsTypes.fetching,
});

export default connect(mapStateToProps)(EditPointsType);
